import { render, staticRenderFns } from "./GoogleOneTap.vue?vue&type=template&id=803998d6"
import script from "./GoogleOneTap.vue?vue&type=script&lang=js"
export * from "./GoogleOneTap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports